import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { login, logout } from '../../redux/slices/authSlice';
import SignIn from './Signin';
import ResetPwd from './ResetPwd';
import loginLogo from '../../assets/login-logo.svg';

export default function Login() {
  const [mode, setMode] = useState('signin'); // 'signin' | 'reset'
  const [isAnimating, setIsAnimating] = useState(false);
  const [resetPhone, setResetPhone] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(logout());
  }, []);

  const switchMode = (newMode) => {
    setIsAnimating(true);
    setTimeout(() => {
      setMode(newMode);
      setTimeout(() => setIsAnimating(false), 50);
    }, 200);
  };

  const handleLoginSuccess = (userInfo) => {
    // 更新 Redux 状态
    dispatch(login(userInfo));
    // 跳转到首页
    navigate('/booth');
  };

  const handleResetSuccess = () => {
    // 重置成功后返回登录
    switchMode('signin');
  };

  const handleForgotPassword = (phone) => {
    setResetPhone(phone);
    switchMode('reset');
  };

  return (
    <div
      className="w-screen h-screen flex items-center justify-center relative overflow-hidden before:absolute before:inset-0 before:bg-black/40 before:z-0"
      style={{
        backgroundImage: `url('https://static.shelingxingqiu.com/Fsk-qq9JnGJJaWj57UYkYDJNP6ZG')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <nav className="fixed top-0 left-0 right-0 z-40 flex items-center justify-between px-4 py-1.5 bg-linear-to-r from-[#167aff] to-[#38b9ff] backdrop-blur-md border-b border-white/10">
        <div className="flex items-center gap-3">
          <div className="inline-flex items-center justify-start h-6.5">
            <img
              src={loginLogo}
              alt="赛事平台"
              className="h-full object-container"
            />
            <span className="text-white border-l border-white/40 text-[21px] ml-3 pl-3 flex items-center font-medium">
              赛事管理系统
            </span>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <a
            href="https://www.dronex.cc/"
            target="_blank"
            rel="noreferrer"
            className="w-20 inline-flex items-center justify-center gap-2 py-2 rounded-md text-sm font-medium text-white hover:text-white/90 hover:bg-white/5 transition"
            aria-label="访问官网"
          >
            <svg
              className="w-4 h-4 text-current"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 2a10 10 0 100 20 10 10 0 000-20z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M2 12h20"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12 2c3.5 3.5 3.5 15 0 19.5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span>官网入口</span>
          </a>
        </div>
      </nav>

      <div className="w-full max-w-md px-6 z-10">
        <div className="mb-10 text-center">
          <h1 className="text-5xl font-bold text-white mb-4 tracking-tight whitespace-nowrap">
            轻松办赛&nbsp;&nbsp;赛事大卖
          </h1>
          <p className="text-lg text-white font-medium">
            智能规划&nbsp;&nbsp;塑造品牌&nbsp;&nbsp;助力经营
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl shadow-slate-900/5 p-8 border border-slate-100 relative">
          <div
            className={`transition-all duration-300 ${
              isAnimating
                ? 'opacity-0 translate-x-4'
                : 'opacity-100 translate-x-0'
            }`}
          >
            {mode === 'signin' ? (
              <SignIn
                onSuccess={handleLoginSuccess}
                onForgotPassword={handleForgotPassword}
              />
            ) : (
              <ResetPwd
                initialPhone={resetPhone}
                onSuccess={handleResetSuccess}
                onBack={() => switchMode('signin')}
              />
            )}
          </div>
          <div className="absolute -left-100 top-20 rounded-md shadow-lg bg-white p-2 flex flex-col items-center text-center text-xs text-slate-800">
            <img
              src="https://statics.dronex.cc/qrcode/__pages_index.jpg"
              alt="小程序二维码"
              className="w-32 h-32 object-cover"
            />
            <span className="mt-2">飞行极控小程序</span>
            <span>手机扫码进入</span>
          </div>
        </div>

        <p className="text-center text-sm text-white mt-6">
          © DroneX 2025 版权所有 粤ICP备2025476630号-1
        </p>
      </div>
    </div>
  );
}
